const SpeakingTypes = {
  SET_SPEAKING_LOADING: 'SPEAKING/SET_SPEAKING_LOADING',
  SET_SPEAKING_FAILURE: 'SPEAKING/SET_SPEAKING_FAILURE',
  SET_SPEAKING_SUCCESS: 'SPEAKING/SET_SPEAKING_SUCCESS',
};

export default SpeakingTypes;